/**
 * 处理 oss 图片url 默认大小为 40*40
 *  例如：
 *  将 https://img.alicdn.com/bao/uploaded/i3/65343260/TB20GORzhxmpuFjSZFNXXXrRXXa_!!65343260.jpg_300x300.jpg
 *  改为 https://img.alicdn.com/bao/uploaded/i3/65343260/TB20GORzhxmpuFjSZFNXXXrRXXa_!!65343260.jpg_40x40.jpg
 */

export const DEFAULT_IMG_PATH = '@/assets/images/no_pic.png"';
const DOMAIN_LIST = [
  'img.alicdn.com',
  'cbu01.alicdn.com',
  'erp-storage-img-new',
  'erp-storage-img',
  'wish.com',
  'jxc-storage',
  'erp-storage-ram',
  'my-live.slatic.net',
  'gaoketian.oss-cn-hangzhou.aliyuncs.com',
  'img.pddpic.com',
];

const getSizeOSS = function (size = 400) {
  const sizes = [30, 40, 50, 70, 100, 200, 400, 500];
  return (
    sizes.find(item => {
      if (item >= size) {
        return item;
      }
    }) ||
    size ||
    400
  );
};

const buildDefaultOption = function (_picPath, _size, _picType) {
  const picPath = _picPath || DEFAULT_IMG_PATH;

  const size = _size ? Math.round(_size / 10) * 10 : 40;
  // 获取图片格式
  const regRes = /(\.png|\.jpg|\.jpeg)/.exec(picPath);
  /**
   * 优先使用传入的图片格式
   * 其次使用获取的格式
   * 如果都没有使用默认的jpg
   */
  const picType = _picType ? '.' + _picType : regRes ? regRes[0] : '.jpg';
  return { picPath, size, picType };
};

const jxcAndErpCoverData = function (picPath, size) {
  let reg_1 = /@+([0-9])+w_+[0-9]+h+(.jpg|.jpeg|.png|.gif)$/i;
  let reg_2 = /\?x-oss-process=style\/([0-9])+x+([0-9])+$/gi;
  if (picPath.includes('@') && reg_1.test(picPath)) {
    picPath = picPath.replace(reg_1, '');
  } else if (reg_2.test(picPath)) {
    picPath = picPath.replace(reg_2, '');
  }
  size = getSizeOSS(size);
  picPath += `?x-oss-process=style/${size}x${size}`;
  return picPath;
};

/**
 * 对来自预设域名列表的图片添加如 '_40x40.jpg' 的后缀
 * @param  {string} picPath [图片路径]
 * @param  {int} size    [尺寸，默认40]
 * @param  {string} picType [图片后缀名，默认'jpg']
 * @return {string}         [处理好的图片路径]
 */

export const buildOssImgUrl = function (_picPath, _size, _picType) {
  let { picPath, size, picType } = buildDefaultOption(_picPath, _size, _picType);

  if (picPath.indexOf('no_pic') > -1) {
    return picPath;
  }
  const domainList = DOMAIN_LIST;
  for (let i = 0; i < domainList.length; i++) {
    const curDomain = domainList[i];
    if (picPath.indexOf(domainList[i]) > -1) {
      switch (curDomain) {
        case 'wish.com':
          if (size < 200) {
            picPath = picPath.replace('-original.', '-small.');
          }
          break;
        case 'erp-storage-ram':
          let reg_4 = /\?x-oss-process=image\/resize,h_+([0-9])+,m_lfit$/gi;
          if (reg_4.test(picPath)) {
            picPath = picPath.replace(reg_4, '');
          }
          picPath += `?x-oss-process=image/resize,h_${size},m_lfit`;
          break;
        case 'erp-storage-img-new':
        case 'erp-storage-img':
        case 'jxc-storage':
          picPath = jxcAndErpCoverData(picPath, size);
          break;
        case 'gaoketian.oss-cn-hangzhou.aliyuncs.com':
          // KMERP-131333 业务处理
          const picUrl = new URL(picPath);
          const search = picUrl.search;
          if (search.length > 0) {
            picPath = picPath.replace(search, '');
          }
          picPath += `?x-oss-process=image/resize,m_fill,h_${size},w_${size}`;
          break;
        case 'img.pddpic.com':
          const picPathUrl = new URL(picPath);
          const urlSearch = picPathUrl.search;
          if (urlSearch.length > 0) {
            picPath = picPath.replace(urlSearch, '');
          }
          picPath += `?imageView2/2/w/${size}/q/80`;
          break;
        case 'img.alicdn.com':
        case 'cbu01.alicdn.com':
        case 'my-live.slatic.net':
          // 无需默认值，有些图片是没有后缀的， 比如 https://img.alicdn.com/bao/uploaded/TB1NyxYkTXYBeNkHFrdL6UiuVXa
          // picType = '.jpg'; // 默认.jpg,

          // 如果上传图片已经是缩略图情况，把缩略图后缀去除
          if (picPath.includes('.jpg')) {
            picType = '.jpg';
            picPath = picPath?.split('.jpg')[0] + picType;
          } else if (picPath.includes('.png')) {
            picType = '.png';
            picPath = picPath?.split('.png')[0] + picType;
          } else if (picPath.includes('.gif')) {
            picType = '.gif';
            picPath = picPath?.split('.gif')[0] + picType;
          } else if (picPath.includes('.bmp')) {
            picType = '.bmp';
            picPath = picPath?.split('.bmp')[0] + picType;
          } else if (picPath.includes('.jpeg')) {
            picType = '.jpeg';
            picPath = picPath?.split('.jpeg')[0] + picType;
          }

        default:
          const suffix = '_' + size + 'x' + size; // 默认_40x40.jpg
          picPath = picPath.replace(/_\d+x{1}\d+(\.png|\.jpg|\.jpeg|\.gif)$/gi, '') + suffix;
      }
      break;
    }
  }
  return picPath;
};

export default {
  DEFAULT_IMG_PATH,
  buildOssImgUrl,
};
